export default __webpack_public_path__ + "static/media/android-s3.3e6dacfe.webp";